import React, { useEffect, useState } from 'react';
import './Service.css';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import axios from 'axios';
import ServicesHeader from './ServiceHeader';
import { motion, time } from 'framer-motion';
import { useParams, useLocation } from 'react-router-dom';
import DOMPurify from 'dompurify';
import BrandSlider from "./Clients";

const ServiceDetails = () => {
  const slideInRight = {
    hidden: { opacity: 0, x: 150 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        type: 'spring',
        bounce: 0.3,
        duration: 1,
      },
    },
  };
  const { slug } = useParams(); // get the slug from the URL
  const [service, setService] = useState([]);
  const [loading, setLoading] = useState(true);
  const decodedSlug = slug ? decodeURIComponent(slug) : '';
  console.log(decodedSlug, "slug")
  const location = useLocation();
  const [data, setData] = useState([]);
  const [addressData, setAddressData] = useState([]);
  const [error, setError] = useState(null)
  const { pathname } = useLocation();

  useEffect(() => {
    axios.get('https://admin.ezerautomotive.co.nz/api/services/')
      .then((res) => {
        const found = res.data.find(s => s.name === decodedSlug);
        setService(found);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Failed to fetch service list', err);
        setLoading(false);
      });
  }, [decodedSlug]);

  useEffect(() => {
    const fetchTimimg = async () => {
      try {
        const response = await fetch('https://admin.ezerautomotive.co.nz/api/working-hours/');
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const result = await response.json();
        setData(result);
        console.log(result, "timimg result")
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTimimg();
  }, []);

  useEffect(() => {
    const fetchAddressData = async () => {
      try {
        const response = await fetch('https://admin.ezerautomotive.co.nz/api/settings/');
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const result = await response.json();
        setAddressData(result);
        console.log(result, "settings")
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAddressData();
  }, []);

  const convertTo12HourFormat = (timeStr) => {
    const [hour, minute] = timeStr.split(":");
    const date = new Date();
    date.setHours(hour, minute);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <Header />
      <ServicesHeader name={service.name} />
      <div className="service-detail-container">
        {/* Left Column */}
        <div className="left-column">
          <img
            // src="/assets/service-details/single-services.jpg"
            src={service.image}
            alt="Service"
            className="service-detail-image"
          />
          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(service.long_description) }} />
          <br></br>

          {/* <div className="service-details">
          <p>
            Sed lectus vestibulum mattis ullamcorper. Ante in nibh mauris cursus...
          </p>

          <div className="bullet-points">
            <ul>
              <li>EST ULLAMCORMER</li>
              <li>NULLA FACILISI ETIAM</li>
              <li>IGNISSIM DIAM QUIS</li>
              <li>DONEC ULTRICES TINCIDUNT</li>
            </ul>
            <ul>
              <li>ARCUN NOD SODALES</li>
              <li>FEUGIAT SCELERISQUE</li>
              <li>MORBI ENIM NUNC FAUCIBUS</li>
              <li>IN EGESTAS ERAT IMPERDIET</li>
            </ul>
            <ul>
              <li>SED EUISMODO</li>
              <li>JUSTO EGET MAGNA</li>
              <li>FERMENTUM IACULIS DIAM</li>
              <li>QUIS ENIM LOBORTIS</li>
            </ul>
          </div>

          <h3>Detailing Services Price List</h3>

          <div className="price-list">
            <div className="price-column">
              <table>
                <thead>
                  <tr>
                    <th>Service Type</th>
                    <th>Price Starts From</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Silencer Coating</td>
                    <td>$49.99</td>
                  </tr>
                  <tr>
                    <td>Anti Rust Coating</td>
                    <td>$12.99</td>
                  </tr>
                  <tr>
                    <td>Feugiat scelerisque</td>
                    <td>$45.99</td>
                  </tr>
                  <tr>
                    <td>Car Varius</td>
                    <td>$23.99</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="price-column">
              <table>
                <thead>
                  <tr>
                    <th>Service Type</th>
                    <th>Price Starts From</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Silencer Coating</td>
                    <td>$49.99</td>
                  </tr>
                  <tr>
                    <td>Anti Rust Coating</td>
                    <td>$12.99</td>
                  </tr>
                  <tr>
                    <td>Feugiat scelerisque</td>
                    <td>$45.99</td>
                  </tr>
                  <tr>
                    <td>Car Varius</td>
                    <td>$23.99</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <p className="bottom-text">
            Vulputate eu scelerisque felis imperdiet proin fermentum leo vel orci...
          </p>
        </div> */}
        </div>

        {/* Right Column */}
        <div className="right-column">
          <motion.div
            className="service-detail-card-main service-box"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
            variants={slideInRight}
          >
            <h3 className='chakra-petch-semibold'>GET SERVICE</h3>
            <p className='font-mulish'>With quality parts to meet every budget and friendly staff trained to make your visit informative and hassle free.</p>
            <button className="btn-orange chakra-petch-semibold">Get Service</button>
          </motion.div>

          <motion.div initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
            variants={slideInRight} className="service-detail-card">
            <h3 className='chakra-petch-semibold'>CONTACT US</h3>
            <p className='font-mulish'>{addressData[0]?.contact_number1}</p>
            <p className='font-mulish'>{addressData[0]?.contact_number2}</p>
            <p className='font-mulish'>{addressData[0]?.email}</p>
          </motion.div>

          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
            variants={slideInRight}
            className="service-detail-card">
            <h3 className='chakra-petch-semibold'>ADDRESS</h3>
            <p className='font-mulish'>{addressData[0]?.address1}</p>
            <p className='font-mulish'>{addressData[0]?.address2}</p>
            <p className='font-mulish'>{addressData[0]?.address3}</p>
            {/* <p className='font-mulish'>31 S Division Street, Montour, IA, 50133, United States</p> */}
          </motion.div>

          <motion.div initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
            variants={slideInRight} className="service-detail-card">
            <h3 className='chakra-petch-semibold'>OPEN HOURS</h3>
            {/* <p className='font-mulish'>Monday: 8 am - 8 pm</p> */}
            {data.map((time, index) => (
              <p className='font-mulish' key={index}>
                {time.day}:
                <span> {convertTo12HourFormat(time.start_time)} -</span>
                <span> {convertTo12HourFormat(time.end_time)}</span>
              </p>
            ))}
            {/* <p className='font-mulish'>Saturday: 9 am - 4 pm</p>
            <p className='font-mulish'>Sunday: Closed</p> */}
          </motion.div>
        </div>
      </div>
      <BrandSlider />
      <Footer />
    </>

  );
};

export default ServiceDetails;
